import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { useCallback, useLayoutEffect, useState } from 'react';
import { createDispatcher, usePlayerContext as useContext, findPlayer } from '@vime/core';

var noop = function noop() {};
/**
 * Returns the closest ancestor player to the given `ref`.
 */


export var usePlayer = function usePlayer(ref) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      player = _useState2[0],
      setPlayer = _useState2[1];

  useLayoutEffect(function () {
    function find() {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = setPlayer;

                if (!ref.current) {
                  _context.next = 16;
                  break;
                }

                _context.next = 4;
                return findPlayer(ref.current);

              case 4:
                _context.t3 = _a = _context.sent;
                _context.t2 = _context.t3 !== null;

                if (!_context.t2) {
                  _context.next = 8;
                  break;
                }

                _context.t2 = _a !== void 0;

              case 8:
                if (!_context.t2) {
                  _context.next = 12;
                  break;
                }

                _context.t4 = _a;
                _context.next = 13;
                break;

              case 12:
                _context.t4 = null;

              case 13:
                _context.t1 = _context.t4;
                _context.next = 17;
                break;

              case 16:
                _context.t1 = null;

              case 17:
                _context.t5 = _context.t1;
                (0, _context.t0)(_context.t5);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }

    find();
  }, [ref.current]);
  return player;
};
/**
 * Binds the given `prop` to the closest ancestor player of the given `ref`. When the property
 * changes on the player, this hook will trigger a re-render with the new value.
 *
 * @param ref The ref to start searching from.
 * @param prop The property to bind to.
 * @param defaultValue The initial value of the property until the the player context is bound.
 */

export var usePlayerContext = function usePlayerContext(ref, prop, defaultValue) {
  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var dispatch = useCallback(ref.current === null ? noop : createDispatcher(ref.current), [ref.current]);
  var setter = useCallback( // eslint-disable-next-line @typescript-eslint/no-shadow
  function (value) {
    dispatch(prop, value);
  }, [dispatch, prop]);
  useLayoutEffect(function () {
    if (ref.current === null) return undefined;
    var cleanup;

    function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return useContext(ref.current, [prop], function (_, newValue) {
                  setValue(newValue);
                });

              case 2:
                cleanup = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }

    connect();
    return function () {
      cleanup === null || cleanup === void 0 ? void 0 : cleanup();
    };
  }, [ref.current, prop]);
  return [value, setter];
};